import { isCurrentYear, isDate, isToday, isYesterday } from './dates'
import i18n from './i18n'

export const monthNamesMap = {
    1: i18n.t('dates.january'),
    2: i18n.t('dates.february'),
    3: i18n.t('dates.march'),
    4: i18n.t('dates.april'),
    5: i18n.t('dates.may'),
    6: i18n.t('dates.june'),
    7: i18n.t('dates.july'),
    8: i18n.t('dates.august'),
    9: i18n.t('dates.september'),
    10: i18n.t('dates.october'),
    11: i18n.t('dates.november'),
    12: i18n.t('dates.december'),
}

export function printDate(date: Date): string | null {
    if (!isDate(date)) {
        return null
    } else if (isYesterday(date)) {
        return i18n.t('dates.yesterday')
    } else if (isToday(date)) {
        return i18n.t('dates.today')
    } else if (isCurrentYear(date)) {
        return date.toLocaleString(i18n.locale(), {
            month: 'long',
            day: 'numeric',
            // year: 'numeric',
        })
    } else {
        return date.toLocaleString(i18n.locale(), {
            month: 'long',
            day: 'numeric',
            year: 'numeric',
        })
    }
}

export function printDistanceOfTime(date: Date, noTime): string | null {
    if (!isDate(date)) {
        return null
    } else if (isToday(date)) {
        if (noTime) {
            return 'Today'
        }
        return printTime(date)
    } else if (isCurrentYear(date)) {
        return date.toLocaleString(i18n.locale(), {
            month: 'short',
            day: 'numeric',
        })
    } else {
        return date.toLocaleString(i18n.locale(), {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
        })
    }
}

export function printTime(date: Date): string | null {
    if (!isDate(date)) {
        return null
    } else {
        return date.toLocaleTimeString(i18n.locale(), {
            hour: 'numeric',
            minute: '2-digit',
        })
    }
}
